import {CategoryEdit} from "../../Api/index"

export default function HandleEditCategoryFunc(selectedCategoryId:string,currCategoryStatus:boolean) {
  return CategoryEdit(selectedCategoryId,currCategoryStatus)
}
